﻿import React from "react";
import { IStationValueFormatter, IStationValueObject, WarningThreshold } from "../../Formatters/IStationValueFormatter";
import { MainSite } from "../../MainSite";
import { PopupChartable } from "../../PopupChartable";
import { Status } from "../../API/LiveData/LiveDataSet";
import { Station } from "../../Model/Station";
import { DataContext } from "../../Contexts/dataContext";

interface Props {
    station: Station;
    valueFormatter: IStationValueFormatter,
    top: number,
    left: number,
    height: number,
    width: number,
    showTitle?: boolean,
    valueTextSizeEm?: number,
    titleTextSizeEm?: number,
    titleText?: string
}

const defaultProps = {
    showTitle: true,
    valueTextSizeEm: 2.5
};

export function ValueBoxComponent(inputtedProps: Props): React.JSX.Element {

    const props = { ...defaultProps, ...inputtedProps };

    const latestData = React.useContext(DataContext);

    let valueObject: IStationValueObject;
    let innerBoxClasses: string = "";

    if (latestData) {

        ////
        //// Differentiate between LiveDataSet and GOMAveragesSet

        // TODO: Why does this not work??
        //if (latestData instanceof Icon.Midi.WebApplication.FrontEnd.GOMAveragesSet) {
        //    console.log('[DataProvider, ValueBoxComponent] Averages...')
        //}

        //if (latestData.Stations[0].GroupAverages) {
        //    console.log('[DataProvider, ValueBoxComponent] Averages...')
        //}
        ////

        valueObject = props.valueFormatter.format(
            latestData.Stations[props.station.Id],
            MainSite.instance.selectedWarningRules
        );

        // Collect css classes
        if (valueObject.Status === null || valueObject.Status === Status.Expired || valueObject.Status !== Status.Good) {
            innerBoxClasses += " midi_siteObsPage_expiring";
        }

        if (valueObject.WarningThreshold == WarningThreshold.Level1) {
            innerBoxClasses += " midi_siteObsPage_exceeded_threshold_1";
        } else if (valueObject.WarningThreshold == WarningThreshold.Level2) {
            innerBoxClasses += " midi_siteObsPage_exceeded_threshold_2";
        } else if (valueObject.WarningThreshold == WarningThreshold.Level3) {
            innerBoxClasses += " midi_siteObsPage_exceeded_threshold_3";
        } 
    }

    return (
        <>
            <React.StrictMode>
                <div
                    className="midi_SiteObservations_value_box_outer"
                    style={{
                        top: `${props.top}%`,
                        left: `${props.left}%`,
                        height: `${props.height}%`,
                        width: `${props.width}%`,
                    }}
                    title={
                        valueObject ? `Timestamp: ${moment(moment.utc(valueObject.Timestamp)).tz(MainSite.instance.selectedRegion.TimeZone).format("YYYY-MM-DD HH:mm")}. Click for parameter popup.` : ""
                    }
                    onClick={(e) => {
                        // Generate parameterPopup()
                        const parameterPopup = new PopupChartable(MainSite.instance, props.station, props.valueFormatter);

                        if (valueObject) {
                            parameterPopup.setSensor(props.valueFormatter.getSensorId() ?? valueObject.Sensor);
                            parameterPopup.setTimestamp(valueObject.Timestamp);
                        }

                        parameterPopup.renderPopup(e);
                    }}
                >
                    {/* Header */}
                    <div
                        className="midi_SiteObservations_value_box_header"
                        style={{
                            fontSize: `${props.titleTextSizeEm}em`
                        }}
                    >
                        {props.titleText ? props.titleText : props.valueFormatter.getShortName()}

                        <div
                            className="midi_SiteObservations_value_box_units"
                        >
                            <span></span>
                            {props.showTitle && props.valueFormatter.getUnits() && valueObject?.Status !== null && valueObject?.Status !== Status.Expired ? props.valueFormatter.getUnits() : ""}
                        </div>

                    </div>

                    {/* Value */}
                    <div
                        className={"midi_SiteObservations_value_box_inner" + innerBoxClasses}
                    >
                        <div
                            className="midi_SiteObservations_value_box_value"
                            style={{
                                fontSize: `${props.valueTextSizeEm}em`
                            }}
                        >
                            {valueObject? valueObject.Value : ''}
                        </div>
                    </div>
                </div>
            </React.StrictMode>
        </>
    );
}